/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

import * as S from './style';
import * as T from '../Typography';
import Icon from '../Icon';

const TickPoint = ({ text }) => {
  return (
    <S.Wrapper>
      <S.IconWrapper>
        <Icon width="24px" height="24px" icon="tickEncircledBlue" />
      </S.IconWrapper>
      <S.Body>
        <T.P16 ml={2} color="gray1" style={{ width: '100%', textAlign: 'left' }}>
          {text}
        </T.P16>
      </S.Body>
    </S.Wrapper>
  );
};

TickPoint.propTypes = {
  text: PropTypes.string,
};

export default TickPoint;
